// Pattern: docs/design-patterns/frontend-form-handling
// Centralized password policy config — single source of truth for all password validation

export interface PasswordPolicy {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumber: boolean;
  requireSymbol: boolean;
}

export const passwordPolicy: PasswordPolicy = {
  minLength: 15,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSymbol: true,
};
